export default "__VITE_ASSET__Cu9S0OwR__"